<template>
  <div>
    <div class="row filesControl" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :for="control.name + '_gui_control'"
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <div class="profileImageWrapper">
          <span v-if="value">
            <img :src="value" class="rounded-circle m1" alt="Circle image" />
          </span>
          <span>
            <b-button
              v-if="!control.readonly"
              :id="`pick-profile-image-${randomeString}`"
              variant="primary"
              size="sm"
            >Select an image</b-button>
            <b-button v-if="value && !control.readonly" variant="danger" size="sm" @click="remove">
              <icon name="remove" style="verticel-align: -3px;" />
            </b-button>
          </span>
        </div>
        <avatar-cropper
          @submit="crop"
          :trigger="`#pick-profile-image-${randomeString}`"
          :labels="{ submit: 'Submit', cancel: 'Cancel' }"
          ref="cropper"
        />
      </div>
    </div>
    <div v-else>
      <label
        :for="control.name + '_gui_control'"
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <div>
        <div class="profileImageWrapper">
          <span v-if="value">
            <img :src="value" class="rounded-circle m1" alt="Circle image" />
          </span>
          <span>
            <b-button
              v-if="!control.readonly"
              :id="`pick-profile-image-${randomeString}`"
              variant="primary"
              size="sm"
            >Select an image</b-button>
            <b-button v-if="value && !control.readonly" variant="danger" size="sm" @click="remove">
              <icon name="remove" style="verticel-align: -3px;" />
            </b-button>
          </span>
        </div>
        <avatar-cropper
          @submit="crop"
          :trigger="`#pick-profile-image-${randomeString}`"
          :labels="{ submit: 'Submit', cancel: 'Cancel' }"
          ref="cropper"
        />
      </div>
    </div>
  </div>
</template>

<script>
// components
import AvatarCropper from 'vue-avatar-cropper'

export default {
  props: ['control', 'labelPosition'],
  components: {
    AvatarCropper,
  },
  data() {
    return {
      value: this.control.value,
      randomeString: null,
      formBuilderInst: null,
    }
  },
  watch: {
    value() {
      this.control.value = this.value
      this.formBuilderInst.setRowDataVal(
        this.control.propName,
        this.control.value
      )
    },
  },
  methods: {
    crop() {
      const cropper = this.$refs.cropper.cropper
      this.value = cropper.getCroppedCanvas().toDataURL()
    },
    remove() {
      this.value = ''
    },
  },
  mounted() {
    this.$nextTick(() => {
      let text = ''
      let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length))

      this.randomeString = text

      this.formBuilderInst = this.$instByClass(this, 'form-builder-root')
    })
  },
}
</script>

<style lang="scss">
.profileImageWrapper {
  align-items: center;
  > span:first-child {
    margin-right: 15px;
  }
  img {
    width: 50px;
    height: 50px;
  }
}
</style>
